module.exports = __webpack_public_path__ + "static/media/galerija_2019 (39).19a8ccae.jpg";